export enum HospitalType {
    PerDiem = 1,
    Travel = 2,
    Locums = 3,
    NonClinical = 4,
    LocalLongTerm = 5,
    Staff = 6,
    WorkforceDisruptionClinical = 7,
    WorkforceDisruptionNonClinical = 8,
    AccessControl = 9,
    InterimLeadership = 10
}
